import React, { ReactElement } from "react";

import classNames from "classnames";

import {
  chatHistoryBarCSS,
  chatHistoryBarFloatingCSS,
  chatHistoryBarIconCSS,
} from "./ChatHistoryBar.styles";
import Button from "../../button";
import { ButtonSize } from "../../types";
import { ChatHistoryBarProps } from "./ChatHistoryBar.types";

export const ChatHistoryBar = ({
  isFullScreen = true,
  openHistoryPanel,
  disabled = false,
  setOpenHistoryPanel,
  handleNewChatClick,
}: ChatHistoryBarProps): ReactElement => {
  return (
    <div
      className={classNames(chatHistoryBarCSS, {
        "in-dialog": !isFullScreen,
        [chatHistoryBarFloatingCSS]: isFullScreen && !openHistoryPanel,
      })}
    >
      <Button
        icon={openHistoryPanel ? "arrow-chevron-left" : "menu-hamburger"}
        onClick={(): void => {
          setOpenHistoryPanel?.(!openHistoryPanel);
        }}
        ariaLabel={`${openHistoryPanel ? "Close" : "Open"} history panel`}
        tooltip={`${openHistoryPanel ? "Close" : "Open"} history panel`}
        tooltipDirectionY="bottom"
        tooltipDirectionX="right"
        className={chatHistoryBarIconCSS}
        disabled={disabled}
      />
      <Button
        secondary
        size={isFullScreen ? ButtonSize.SMALL : ButtonSize.EXTRA_SMALL}
        onClick={(): void => handleNewChatClick?.()}
        disabled={disabled}
      >
        New chat
      </Button>
    </div>
  );
};
